import { Auth, API } from 'aws-amplify';

const requestHeaders = async () => {
  return {
    'Content-Type': 'application/json',
    Authorization: `${(await Auth.currentSession())
      .getAccessToken()
      .getJwtToken()}`
  };
};

const addUserToGroup = async function(
  { dispatch, getters, commit },
  { username, groupname }
) {
  if (!username) {
    throw Error('ERROR::ACCOUNT_SIGN_IN: No parameters provided.');
  }
  let path = '/addUserToGroup';
  try {
    let payload = {
      body: {
        username,
        groupname
      },
      headers: await requestHeaders()
    };
    let req = await API.post('AdminQueries', path, payload);
    if (req.message.split(' ')[0] === 'Success') {
      return req.message;
    }
    throw Error('Error enabling user', req);
  } catch (error) {
    throw Error(error);
  }
};

export default addUserToGroup;
